import type { TFunction } from 'i18next';

import type { Importer } from '@feathr/blackbox';

/** The import's name as the customer typed it, or a generic name when it has none. */
export function getImportDisplayName(importer: Importer, t: TFunction): string {
  return importer.get('name')?.trim() || t('Unknown import');
}
